import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20elegant%20abstract%20floral%20illustration%20with%20warm%20peach%20rose%20and%20cream%20tones%2C%20minimalist%20feminine%20design%2C%20delicate%20botanical%20elements%2C%20clean%20light%20background%2C%20healing%20and%20wellness%20concept%2C%20soft%20gradients%20with%20organic%20shapes&width=1600&height=700&seq=hero-main-2026&orientation=landscape"
        alt="女性健康指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4">
        <span className="inline-block px-4 py-1.5 mb-5 text-xs font-medium bg-primary-500/90 text-white rounded-full tracking-wide">
          科学 · 专业 · 关爱
        </span>
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          女性生殖系统完全指南
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          全面解析女性生殖系统的解剖结构、生理功能与常见健康问题，帮助女性科学认识自身身体，守护生殖健康。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/anatomy"
            className="px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}